import { MatDatetimePickerInputEvent } from '@angular-material-components/datetime-picker';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccountDTO } from '../../../../../shared/account-dto';
import { AccountService } from '../../account.service';
import { CustomerService } from '../../customer.service';
import { LoaderService } from '../../loader.service';

@Component({
  selector: 'pv-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss']
})
export class CartItemComponent implements OnInit {
  @Input() item;
  @Input() bonus: boolean;
  @Output() refresh: EventEmitter<any> = new EventEmitter<any>();
  account: AccountDTO;
  errorMessage: string = '';
  loading = false;

  constructor(
    private customerService: CustomerService,
    private loaderService: LoaderService,
    private accountService: AccountService,
  ) { }

  ngOnInit() {
    this.account = this.accountService.account
    this.accountService.accountSubject
    .subscribe(account => this.account = account)

    // Remove the + Digital for wholesale
    if (this.customerService.checkoutDTO.customer.is_wholesale && this.item) {
      this.item.format = this.item.format.replace('+ Digital', '')
    }

    // format dates for UTC no matter what
    if (this.newUTCDateFromDBDate(this.item.preorderDate) > this.newUTCDateFromDBDate(new Date())) {
      this.item.preorderDate = this.newUTCDateFromDBDate(this.item.preorderDate);
    }
    else {
      this.item.preorderDate = '';
    }
  }

  hasSale() {
    return this.item.price != this.item.originalPrice
  }

  onQuantityChange(event: any, item) {
    const quantity = event.target.value
    if (!Number(quantity) || quantity < 1) { return }
    this.errorMessage = null
    this.loading = true;
    this.loaderService.show()

    this.customerService.changeQuantity({ cartItemId: item.id, quantity })
    .subscribe(([a, cart]) => {
      this.customerService.updateCheckoutDTO({ cart })
      this.loaderService.hide();
      this.loading = false;
      this.errorMessage = null;
    }, error => {
      this.loaderService.hide()
      this.loading = false;
      this.errorMessage = error.error.message
    })
  }

  remove(item)
  {
    this.errorMessage = null;

    this.loading = true;

    this.customerService.removeItemFromCart({ cartItemId: item.id })
      .subscribe(
        (cartDTO) => {
            this.customerService.updateCheckoutDTO({ cart: cartDTO });
            console.log("... supposedly updated checkoutDTO ...\n" + JSON.stringify(cartDTO));
            this.loading = false;
          },

        (err) => {
            this.loading = false;
          }
      );

      // #1200 TO DO: move this from inside removeItemFromCart to here...? maybe it would fire better here?
      // this.trackingService.event('remove_from_cart', this.account.id, {
  }

  newUTCDateFromDBDate(date) {
    var origDateObj = new Date(date);

    // set this object up with the origDateObj.getUTCDate() as the day
    var newDateObj = new Date(origDateObj.getUTCFullYear(), origDateObj.getUTCMonth(), origDateObj.getUTCDate());
    return newDateObj;
  }

}